<template>
  <div class="product bps" v-bind:class="{contrasted: isPageContrasted, fontBigger: isFontBigger}">
    <header class="page-header" data-aos="fade-up">
      <div class="container">
        <div class="heading-text" data-aos="fade-up" v-if="lang === 'pl'">System ochrony ptaków na Farmy Wiatrowe</div>
        <div class="heading-text" data-aos="fade-up" v-if="lang !== 'pl'">Bird Protection System for Wind Farms</div>
        <p data-aos="fade-up" data-aos-delay="100"></p>
        <span class="line" data-aos="zoom-in-left" data-aos-delay="150"></span>
        <p data-aos="fade-up" data-aos-delay="200"></p>
        <div class="btn-hover">
          <router-link to="/products/farms/presentation" class="btn orange" data-aos="fade-up" data-aos-delay="250">
            {{$t('component.watchPresentation')}}<span/></router-link>
        </div>
        <div
          class="btn-hover"
          @click="$modal.show('video-static')"
        >
          <div class="btn orange" data-aos="fade-up" data-aos-delay="250">{{$t('component.watchVideo')}}<span/></div>
        </div>
      </div>
    </header>

    <div id="top" class="why-us-solution">
      <div class="elements">
        <div class="element bps clearfix">
          <div class="text-box">
            <ul v-if="lang === 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
                  Celem projektu jest stworzenie systemu, który w niezawodny sposób będzie wykrywał ptaki na farmach wiatrowych. Będzie on oparty na najnowszych technologiach, wykorzystywał stereoskopię i edge computing, a testy terenowe będziemy wykonywać na farmach wiatrowych, które należą do naszego partnera strategicznego PGE EO SA. Realizacja projektu trwa 3 lata i skończy się w 2021 r.
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">Tytuł projektu:<br/>
Realizacja prac B+R, prowadzących do wdrożenia nowego rozwiązania - MULTIREJESTRATOR PLUS dla monitorowania i kontroli systemu elektroenergetycznego pod kątem efektywności eksploatacji, wydłużenia czasu życia i optymalizacji oddziaływania na otoczenie farm wiatrowych.
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
                  Cel projektu:<br/>
Celem projektu jest przeprowadzenie prac B+R prowadzących do opracowania prototypu systemu radiowo wizyjnego, który pozwoli podnieść sprawność i wydajność pracy turbin wiatrowych.
                <br/><br/><br/>
                Wartosć projektu:<br/>
                4 109 660,41PLN
                  <br/><br/>
                  Dofinansowanie projektu z UE:<br/>
                3 021 687.62PLN
                </span>
              </li>
            </ul>
            <ul v-if="lang !== 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
                The aim of the project is to create a system that will reliably detect birds on wind farms. It will be based on the latest technologies, using stereoscopy and edge computing. We will perform field tests on wind farms that belong to our strategic partner PGE EO SA. The project will be implemented for 3 years and will end in 2021.
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">Project title:<br/>
Realization of R&D works leading to the implementation of a new solution - MULTIREJESTRATOR PLUS for monitoring and control of the power system in terms of operational efficiency, the life span extending and optimizing the impact on the surrounding wind farms.
  </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
                 The aim of the project is to carry out R&D works leading to the development of a radio and video prototype system that will improve the efficiency and performance of wind turbines, which will affect the growth of innovation in the national electricity sector. The project will be implemented by a qualified project team in 4 research tasks, the aim of which will be to design a complete vision system that allows the prediction of bird traffic near wind farms. The project will end with the creation of technical documentation enabling the implementation of MULTIREJESTRATOR PLUS technology on the market. It is planned to cover the results of R&D works with patent protection on the Polish, British and then European markets.
MULTIREJESTRATOR PLUS will ensure uninterrupted or rarely interrupted work of wind farms, through the active protection of valuable bird species.
                  <br/><br/><br/>
                Project value:<br/>
                4 109 660,41PLN
                  <br/><br/>
                 Amount of founding from UE:<br/>
                3 021 687.62PLN
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../store/store';
  import FooterMain from '../components/FooterMain';
  import FooterMoreInformation from '../components/FooterMoreInformation';
  import VideoBox from '../components/VideoBox';
  import Counter from '../components/Counter';
  import smoothScroll from '../helpers/SmoothScroll';

  export default {
    name: 'farms-product',
    components: {
      FooterMain,
      FooterMoreInformation,
      VideoBox,
      Counter
    },
    data: function () {
      return {
        circleValues: [
          {
            before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter'),
          },
        ]

      }
    },
    computed: {
      lang: () => {
        return store.state.lang;
      },
      isPageContrasted(){
        return store.state.isPageContrasted
      },
      isFontBigger(){
        return store.state.isPageFontBigger
      },
      smoothScroll: () => smoothScroll
    },

    methods: {},
    mounted: function () {
      store.state.isAccessibilityVisible = true;
    },
    destroyed: function () {
      store.state.isAccessibilityVisible = false;
    },
  }
</script>

<style>
  .bps header.page-header .heading-text {
    max-width: 600px;
  }

  .product .why-us-solution .elements .element.bps .text-box {
    float: left;
    max-width: initial;
    margin-top: 20px;
    margin-bottom: 100px;
  }

  .product .why-us-solution .elements .element.bps .text-box ul li .text {
    margin-top: -20px;
  }


  .ue{
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
    text-align: center;
  }

  .ue img{
    max-width: 940px;
    width: 35%;
  }

  .product.contrasted{
    background: #000;
    color: yellow;
  }

  .product.contrasted .heading-text{
    color: yellow;
  }
  .product.contrasted .ue{
    background: #000;
  }

  .product.contrasted header a{
    color: yellow;
    background: #000;
  }
  .product.contrasted .btn{
    color: yellow;
    background: #000;
  }
  .product.fontBigger .why-us-solution .elements .element .text-box ul li .text{
    font-size: 1.6em;
    line-height: 1.6em;
  }


</style>



// WEBPACK FOOTER //
// BPS.vue?75c66cc4